// Module
var code = "<div id=cb-cookie-banner class=\"alert alert-dark text-center mb-0\" role=alert> Wir nutzen nur essentielle Cookies um Ihre Erfahrung zu verbessern! <button type=button class=\"btn btn-primary btn-sm ms-3 ml-3\" onclick=window.cb_hideCookieBanner()> Ich stimme zu </button> </div>";
// Exports
module.exports = code;